<template>
  <div>
    <div class="pb-4">
      <PageHeader title="مدیریت دوره" :items="pageHeaderItems" />
    </div>
    <TabLink :items="links">
      <b-button variant="outline-primary" @click="$bvModal.show('class-login')">ورود به کلاس</b-button>
    </TabLink>
    <div v-if="$route.fullPath !== '/list/courses/add' && !$route.params.courseId" class="card p-3">برای اضافه کردن این بخش ابتدا باید دوره را ثبت نمایید</div>
    <router-view v-else></router-view>
    <b-modal id="class-login" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>ورود به کلاس</template>
      <AdminClassLogin />
    </b-modal>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TabLink from '../../../components/common/TabLink.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
import AdminClassLogin from '../../../components/dadban/courses/AdminClassLogin.vue'
export default {
  page: {
    title: 'مدیریت دوره',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-courses',
  components: {
    TabLink,
    PageHeader,
    AdminClassLogin,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
    }
  },
  computed: {
    links() {
      if (this.$route.params.courseId !== undefined) {
        return [
          { title: 'ثبت دوره', link: this.$route.params.courseId ? `/list/courses/detail/${this.$route.params.courseId}` : '/list/courses/add' },
          { title: 'سرفصل ها', link: `/list/courses/${this.$route.params.courseId}/headlines` },
          { title: 'پیش نیاز', link: `/list/courses/${this.$route.params.courseId}/courseprerequisites` },
          {
            title: 'سوالات متداول',
            link: this.$route.params.courseId ? `/list/courses/questions/${this.$route.params.courseId}` : '/list/courses/questions',
          },
          { title: 'اعضا', link: `/list/courses/${this.$route.params.courseId}/users?pageNumber=1&perPage=20` },
          { title: 'نظرات', link: `/list/courses/${this.$route.params.courseId}/comments` },
        ]
      }
      return [
        { title: 'ثبت دوره', link: '/list/courses/add' },
        { title: 'سرفصل ها', link: '#' },
        { title: 'پیش نیاز', link: '#' },
        {
          title: 'سوالات متداول',
          link: '#',
        },
        { title: 'اعضا', link: '#' },
        { title: 'نظرات', link: '#' },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .modal.show .modal-dialog {
  min-width: 611px !important;
  width: 611px !important;
}

::v-deep .modal-body {
  min-height: 400px !important;
}
</style>
